import { Modal } from "react-bootstrap";

type User = {
  usersPositions?: {
    first_name: string;
    last_name: string;
  };
  createdlocationUserAccount?: {
    first_name: string;
    last_name: string;
  };
};

type Props = {
  show: boolean;
  onClose: () => void;
  users: User[];
  label: string;
};

const SensorUserModel = ({ show, onClose, users, label }: Props) => {
  return (
    <Modal
      className="comman-modal"
      show={show}
      onHide={onClose}
      centered
    >
      <Modal.Header closeButton className="comman-modal-header">
        <Modal.Title>{label}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="comman-modal-body">
        {users && users.length > 0 ? (
          <div className="border rounded">
            {users.map((user, index) => {
              const id = index; // fallback id if missing
              const firstName =
                user.usersPositions?.first_name ||
                user.createdlocationUserAccount?.first_name ||
                "";
              const lastName =
                user.usersPositions?.last_name ||
                user.createdlocationUserAccount?.last_name ||
                "";

              return (
                <div
                  key={id}
                  className={`p-2 text-start border-bottom ${
                    index === users.length - 1 ? "" : ""
                  }`}
                >
                  {firstName} {lastName}
                </div>
              );
            })}
          </div>
        ) : (
          <p>No users found</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default SensorUserModel;
